import { FC } from 'react';
import { When } from '@edikk-edikk/if';
import {
  FooterAge,
  FooterName,
  FooterPrice,
  useAdvertCardContext,
} from '#advert/components/card';
import advertCardFooterCss from '../assets/advert-card-footer.module.scss';

const Footer: FC = () => {
  const { advert } = useAdvertCardContext();

  return (
    <div className={advertCardFooterCss.advertCardFooter}>
      <div className={advertCardFooterCss.advertCardFooter__row}>
        <FooterName />
        <FooterPrice />
      </div>
      <When condition={advert.age}>
        <div className={advertCardFooterCss.advertCardFooter__row}>
          <FooterAge />
        </div>
      </When>
    </div>
  );
};

export { Footer };
